import type { Category } from '../../types/product'

export const CATEGORIES: Category[] = [
  {
    id: 'fresh-produce',
    name: 'Fresh Produce',
    icon: 'Leaf',
    subcategories: ['Fruits', 'Vegetables', 'Herbs & Salads'],
  },
  {
    id: 'dairy-eggs',
    name: 'Dairy & Eggs',
    icon: 'Milk',
    subcategories: ['Milk', 'Cheese', 'Eggs', 'Yogurt', 'Butter'],
  },
  {
    id: 'bakery',
    name: 'Bakery',
    icon: 'Croissant',
    subcategories: ['Bread', 'Cakes', 'Pastries', 'Buns'],
  },
  {
    id: 'meat-seafood',
    name: 'Meat & Seafood',
    icon: 'Beef',
    subcategories: ['Chicken', 'Beef', 'Mutton', 'Fish', 'Prawns'],
  },
  {
    id: 'pantry-staples',
    name: 'Pantry Staples',
    icon: 'Package',
    subcategories: ['Rice', 'Flour', 'Oil', 'Spices', 'Sugar', 'Salt'],
  },
  {
    id: 'frozen-foods',
    name: 'Frozen Foods',
    icon: 'Snowflake',
    subcategories: ['Frozen Vegetables', 'Ice Cream', 'Ready Meals', 'Frozen Fish'],
  },
  {
    id: 'beverages',
    name: 'Beverages',
    icon: 'Coffee',
    subcategories: ['Water', 'Juice', 'Soft Drinks', 'Tea', 'Coffee'],
  },
  {
    id: 'snacks',
    name: 'Snacks & Confectionery',
    icon: 'Cookie',
    subcategories: ['Chips', 'Biscuits', 'Chocolates', 'Nuts', 'Candy'],
  },
  {
    id: 'household',
    name: 'Household',
    icon: 'Home',
    subcategories: ['Cleaning Supplies', 'Paper Products', 'Laundry', 'Kitchen Supplies'],
  },
  {
    id: 'personal-care',
    name: 'Personal Care',
    icon: 'Sparkles',
    subcategories: ['Soap', 'Shampoo', 'Toothpaste', 'Skincare', 'Deodorant'],
  },
]

export const LOCATIONS = [
  'Dhaka',
  'Chittagong',
  'Sylhet',
  'Rajshahi',
  'Khulna',
  'Barisal',
  'Rangpur',
  'Mymensingh',
]
